/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*********************************************!*\
  !*** ./src/scripts/product/product-form.js ***!
  \*********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var productForm = function productForm() {
  return {
    selectedVariant: {
      id: 0,
      price: 0,
      compare_at_price: 0,
      variant_title: 'Default Title'
    },
    selectedSellingPlan: {
      id: '',
      name: '',
      price: 0,
      dc_amt: 0,
      dc_type: ''
    },
    allVariantButtons: [],
    allPackBtns: [],
    poductSelectData: '',
    showStickyButton: false,
    thisForm: {},
    productQuantity: 1,
    productDiscount: 0,
    init: function init(el) {
      var inStockContainer = document.querySelector('[data-form-container]');
      var _this = this;
      document.body.addEventListener('click', function (e) {
        var dropdownExpanded = document.querySelectorAll('.dd-wrapper.expanded');
        if (dropdownExpanded && dropdownExpanded.length == 1 && e.target !== e.target.querySelector('.dd-toggle')) {
          _this.closeAllDd();
        }
      });
      _this.showStickyButton = !_this.isElementInViewport(inStockContainer);
      window.addEventListener('scroll', function (event) {
        if (inStockContainer) {
          _this.showStickyButton = !_this.isElementInViewport(inStockContainer);
        }
      });
    },
    initializeProductForm: function initializeProductForm(el) {
      this.allVariantButtons = el.querySelectorAll('.variant-selector .variant-btn');
      this.allPackBtns = el.querySelectorAll('.pack-button-js');
      this.productSelectData = el.querySelectorAll('.product-select-data')[0];
      this.thisForm = el.querySelectorAll('form[action="/cart/add"]')[0];
    },
    getInitialVariant: function getInitialVariant(el) {
      var _this = this;
      var thisVariantSelector = el;
      var firstAvailableVariant = thisVariantSelector.querySelectorAll('.variant-btn[availability="true"]')[0];
      _this.selectedVariant.id = firstAvailableVariant.getAttribute('data-variant-id');
      var variantSelected = this.productSelectData.querySelectorAll("option[value=\"".concat(_this.selectedVariant.id, "\"]"))[0];
      _this.selectedVariant.compare_at_price = variantSelected.getAttribute('data-variant-compareprice');
      _this.selectedVariant.price = variantSelected.getAttribute('data-variant-price');
      firstAvailableVariant.classList.add('selected');
    },
    getCurrentVariant: function getCurrentVariant() {},
    changeVariant: function changeVariant(el) {
      var _this = this;
      var thisVariantId = el.getAttribute('data-variant-id');
      var thisAvailability = el.getAttribute('availability');
      if (thisAvailability == 'true') {
        _this.selectedVariant.id = thisVariantId;
        var variantSelected = this.productSelectData.querySelectorAll("option[value=\"".concat(_this.selectedVariant.id, "\"]"))[0];
        _this.selectedVariant.price = variantSelected.getAttribute('data-variant-price');
        _this.selectedVariant.compare_at_price = variantSelected.getAttribute('data-variant-compareprice');
        if (_this.selectedVariant.compare_at_price > _this.selectedVariant.price) {
          document.querySelector('.product-compare-price').innerHTML = formatMoney(_this.selectedVariant.compare_at_price, "£{{amount}}");
        } else {
          document.querySelector('.product-compare-price').innerHTML = '';
        }
        _this.allVariantButtons.forEach(function (variantBtn) {
          variantBtn.classList.remove('selected');
        });
        el.classList.add('selected');
        var subVariantSelected = el.parentNode.parentNode.querySelector(".sub-variant-wrapper .sub-variant-selector[data-variant-id=\"".concat(thisVariantId, "\"] .sub-variant-item.selected input[type=\"radio\"]"));
        var subVariantType = subVariantSelected.getAttribute('data-purchase-type');
        if (subVariantType == 'subscription') {
          var sellingPlanId = subVariantSelected.parentNode.parentNode.parentNode.querySelector('.selling-plan-dd input[type="radio"]:checked').value;
          var sellingPlanPrice = subVariantSelected.parentNode.parentNode.parentNode.querySelector('.selling-plan-dd input[type="radio"]:checked').getAttribute('data-dc-price');
          ;
          _this.selectedSellingPlan.id = sellingPlanId;
          _this.selectedSellingPlan.price = sellingPlanPrice;
          document.querySelector('.pack-block-js').classList.add('hidden');
        } else {
          document.querySelector('.pack-block-js').classList.remove('hidden');
          _this.selectedSellingPlan.id = '';
        }
      }
    },
    changePack: function changePack(quantityInput, quantity, percent_discount, el) {
      var _this = this;
      quantityInput.value = quantity;
      this.productQuantity = quantity;
      this.productDiscount = percent_discount / 100;
      _this.allPackBtns.forEach(function (PackBtn) {
        PackBtn.classList.remove('selected');
      });
      el.classList.add('selected');
    },
    getPurchaseType: function getPurchaseType(el, quantityInput) {
      var _this = this;
      var purchaseType = el.getAttribute('data-purchase-type');
      var subVariantSelector = el.parentNode.parentNode.parentNode;
      var allSubVariantSelector = subVariantSelector.parentNode.querySelectorAll('.sub-variant-item');
      var subscriptionControlWrapper = subVariantSelector.parentNode.querySelector('.subscription-control-wrapper');
      var packBlock = document.querySelector('.pack-block-js');
      if (purchaseType == 'subscription') {
        var selectedSellingPlan = document.querySelector(".selling-plan-dd[data-variant-id=\"".concat(_this.selectedVariant.id, "\"] input[type=\"radio\"]:checked"));
        _this.setSellingPlanId(selectedSellingPlan);
        subscriptionControlWrapper.classList.add('active');
        quantityInput.value = 1;
        packBlock.classList.add('hidden');
      } else {
        _this.selectedSellingPlan.id = '';
        subscriptionControlWrapper.classList.remove('active');
        quantityInput.value = this.productQuantity;
        packBlock.classList.remove('hidden');
      }
      allSubVariantSelector.forEach(function (subVarSelector) {
        subVarSelector.classList.remove('selected');
      });
      subVariantSelector.classList.add('selected');
    },
    setSellingPlanId: function setSellingPlanId(selectedSellingPlan) {
      var _this = this;
      _this.selectedSellingPlan.id = selectedSellingPlan.value;
      _this.selectedSellingPlan.name = selectedSellingPlan.getAttribute('data-selling-plan-name');
      _this.selectedSellingPlan.price = selectedSellingPlan.getAttribute('data-dc-price');
      _this.selectedSellingPlan.dc_type = selectedSellingPlan.getAttribute('price-adjustment-type');
      _this.closeAllDd();
    },
    closeAllDd: function closeAllDd() {
      var allDropDown = document.querySelectorAll('.dd-wrapper');
      allDropDown.forEach(function (ddItem) {
        ddItem.classList.remove('expanded');
      });
    },
    toggleDD: function toggleDD(e) {
      var _this = this;
      var thisDdToggle = e.target;
      var ddWrapper = e.target.parentNode.parentNode;
      if (ddWrapper.classList.contains('expanded')) {
        ddWrapper.classList.remove('expanded');
      } else {
        e.stopPropagation();
        ddWrapper.classList.add('expanded');
      }
    },
    productFormSubmit: function productFormSubmit(e) {
      e.preventDefault();
      var _this = this;
      var thisForm = e.currentTarget.closest("form");
      var itemsToAdd = [{
        'id': thisForm.querySelector('input[name="id"]').value,
        'quantity': thisForm.querySelector('input[name="quantity"]').value
      }];
      if (_this.selectedSellingPlan.id !== '') {
        itemsToAdd[0].selling_plan = thisForm.querySelector('input[name="selling_plan"]').value;
      }

      // console.log('itemsToAdd', itemsToAdd);
      var formData = {
        "items": itemsToAdd
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        // console.log('resp add', response)
      }).then(function (data) {
        window.dispatchEvent(new Event('cart:updated'));
        document.body.classList.add('slide-cart-active');
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    },
    togglePopup: function togglePopup(e) {
      document.body.classList.add('pdp-popup-active');
    },
    toggleSecondPopup: function toggleSecondPopup(e) {
      document.body.classList.add('pdp-second-popup-active');
    },
    scrollToReviews: function scrollToReviews(e) {
      var reviewEntries = document.querySelectorAll('.review-entries')[0];
      window.scrollTo({
        top: (reviewEntries === null || reviewEntries === void 0 ? void 0 : reviewEntries.offsetTop) - 100,
        behavior: 'smooth'
      });
    },
    isElementInViewport: function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.top + el.clientHeight >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (productForm);
document.addEventListener("alpine:init", function () {
  Alpine.data("productForm", productForm);
});
/******/ })()
;